/** Нормализация названия цели отбора / фактора для сравнения. */
export function normalizeCatalogName(name) {
  return String(name || "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

/** Цель отбора «Санитарно-эпидемиологический мониторинг». */
export function isSanitaryEpidemiologicalMonitoring(purpose) {
  const name = normalizeCatalogName(
    typeof purpose === "string" ? purpose : purpose?.name
  );
  return name.includes("санитарно-эпидемиологический мониторинг");
}

/** Цель отбора «Контрольный закуп (мониторинг безопасности)». */
export function isControlPurchasePurpose(purpose) {
  const name = normalizeCatalogName(
    typeof purpose === "string" ? purpose : purpose?.name
  );
  return name.includes("контрольный закуп");
}

/** Фактор «Водные ресурсы». */
export function isWaterResourcesFactor(factor) {
  const name = normalizeCatalogName(
    typeof factor === "string" ? factor : factor?.name
  );
  return name.includes("водные ресурсы");
}

/** Показывать поле «Фактор». */
export function shouldShowFactor(purpose) {
  return isSanitaryEpidemiologicalMonitoring(purpose);
}

/** Показывать поле «Объект» (только для фактора «Водные ресурсы»). */
export function shouldShowCommitteeObject(purpose, factor) {
  return shouldShowFactor(purpose) && isWaterResourcesFactor(factor);
}
